module.exports = __webpack_public_path__ + "static/harrai-03bf1d36712feb46e3095457caac70ca.jpg";